export default [
    // MODE:
    // always_show : แสดงตลอดเวลา

    // show_on_not_detail_mode_or_select : แสดงตอนไม่ใช่โหมดละเอียด
    // ถ้าเป็นโหมดละเอียดต้องเลือกก่อนถึงจะแสดง ต้องใส่ data_select ด้วย

    // show_only_on_detail_mode: แสดงเฉพาะตอนเลือกในโหมดละเอียด

    // status_field : แสดงตอนให้แสดงสถานะ หรือ อยู่ในโหมดกำหนดสถานะ

    //------------------------------------

    // DISPLAY MODE:
    // normal : แสดงตามปกติ
    // object_translator : ใช้ตัวแปลภาษา
    // เว้นว่าง : ไม่แสดง ต้องเขียนวิธีการแสดงเอาเองใน ==DISPLAY==
    {
        key_name: '1',
        use_translate: false,
        text: "#",
        mode: "always_show",
        text_mode: "right",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: '2',
        use_translate: true,
        text: "applicants_report_list.registration_no",
        mode: "always_show",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: '3',
        use_translate: true,
        text: "applicants_report_list.name_surname",
        mode: "always_show",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: 'name_surname_eng',
        use_translate: true,
        text: "applicants_report_list.name_surname",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: '',
        data_name: '',
        data_select: "nameSurname_eng",
        show_on_passed_mode: true,
    },
    {
        key_name: 'applied_timestamp',
        use_translate: true,
        text: "applicants_report_list.applied_timestamp",
        text_mode: "left",
        display_mode: '',
        data_name: '',
        // data_select: "applied_timestamp", กำลังแก้ตรงนี้
        show_on_passed_mode: true, 
    }, 
    {
        key_name: '5',
        use_translate: false,
        text: "สถานะ/Status",
        mode: "status_field",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    // ระดับบัณฑิตศึกษา ----------------------------
    {
        key_name: 'graduate_inter',
        use_translate: false,
        text: "ค่าเทอม Inter",
        mode: "status_field_graduate",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: 'graduate_package_fee',
        use_translate: false,
        text: "ค่าเทอม /////////////",
        mode: "status_field_graduate",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: 'graduate_package_fee_pay_difference',
        use_translate: false,
        text: "ส่วนต่าง (+หรือ-ตามด้วยตัวเลข)",
        mode: "status_field_graduate",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: 'graduate_package_fee_pay_difference_text',
        use_translate: false,
        text: "ส่วนต่าง (ข้อความ) ////////////////",
        mode: "status_field_graduate",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    {
        key_name: 'graduate_save',
        use_translate: false,
        text: "บันทึก",
        mode: "status_field_graduate",
        text_mode: "left",
        display_mode: '',
        data_name: '',
    },
    // GAT PAT ----------------------------
    {
        key_name: 'gat_pat_score_summary',
        text: "รวมคะแนน",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'SUMMARY', // เอาไว้เทียบกับ index เพื่อใส่สี
        data_name: 'summary', // เอาไว้ดึงข้อมูลของเด็กมาแสดง
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_gat',
        text: "GAT",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'GAT_WEIGHT',
        data_name: 'max_standard_gat_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_gat_1',
        text: "GAT 1",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'GAT_1_WEIGHT',
        data_name: 'max_standard_gat_1_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_gat_2',
        text: "GAT 2",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'GAT_2_WEIGHT',
        data_name: 'max_standard_gat_2_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_pat_1',
        text: "PAT 1",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'PAT_1_WEIGHT',
        data_name: 'max_standard_pat_1_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_pat_2',
        text: "PAT 2",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'PAT_2_WEIGHT',
        data_name: 'max_standard_pat_2_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_pat_3',
        text: "PAT 3",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'PAT_3_WEIGHT',
        data_name: 'max_standard_pat_3_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_pat_4',
        text: "PAT 4",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'PAT_4_WEIGHT',
        data_name: 'max_standard_pat_4_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_pat_5',
        text: "PAT 5",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'PAT_5_WEIGHT',
        data_name: 'max_standard_pat_5_score',
        hide_on_passed_mode: true,
    },
    {
        key_name: 'gat_pat_pat_6',
        text: "PAT 6",
        mode: "gat_pat",
        text_mode: "right",
        field_name: 'PAT_6_WEIGHT',
        data_name: 'max_standard_pat_6_score',
        hide_on_passed_mode: true,
    },

    // ------------------------------------
    {
        key_name: '4',
        use_translate: true,
        text: "applicants_report_list.citizen_id",
        mode: "show_on_not_detail_mode_or_select",
        text_mode: "left",
        display_mode: "normal",
        data_name: 'CITIZEN_ID',
        data_select: "citizen_id",
        hide_on_passed_mode: true,
    },
    {
        key_name: '6',
        use_translate: true,
        text: "applicants_report_list.email",
        mode: "show_on_not_detail_mode_or_select",
        text_mode: "left",
        display_mode: "normal",
        data_name: 'EMAIL',
        data_select: "email",
        hide_on_passed_mode: true,
    },
    {
        key_name: '7',
        use_translate: true,
        text: "applicants_report_list.mobile",
        mode: "show_on_not_detail_mode_or_select",
        text_mode: "left",
        display_mode: "normal",
        data_name: 'MOBILE',
        data_select: "mobile",
        hide_on_passed_mode: true,
    },
    {
        key_name: '8',
        use_translate: true,
        text: "applicants_report_list.project",
        mode: "show_on_not_detail_mode_or_select",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'PROJECT_NAME',
        data_select: "project",
    },
    {
        key_name: 'address',
        use_translate: true,
        text: "applicants_report_list.address",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'ADDRESS',
        data_select: "address",
    },
    {
        key_name: '9',
        use_translate: true,
        text: "applicants_report_list.notice",
        mode: "show_on_not_detail_mode_or_select",
        text_mode: "left",
        display_mode: '',
        data_name: '',
        data_select: "notice",
        hide_on_passed_mode: true,
    },
    {
        key_name: 'notice_passed_order',
        use_translate: true,
        text: "applicants_report_list.notice",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: '',
        data_name: '',
        data_select: "",
    },
    {
        key_name: '10',
        use_translate: true,
        text: "info_card.birthday",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'BIRTHDAY',
        data_select: "birthday",
    },
    {
        key_name: '11',
        use_translate: true,
        text: "info_card.nation",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'NATION_NAME',
        data_select: "nation",
    },
    {
        key_name: 'order_1',
        use_translate: true,
        text: "applicants_report_list.order_1",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: "object_translator",
        data_name: 'ORDER_1_CURRICULUM_NAME',
        data_select: "order_1",
    },
    {
        key_name: 'order_2',
        use_translate: true,
        text: "applicants_report_list.order_2",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: "object_translator",
        data_name: 'ORDER_2_CURRICULUM_NAME',
        data_select: "order_2",
    },
    {
        key_name: 'order_3',
        use_translate: true,
        text: "applicants_report_list.order_3",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: "object_translator",
        data_name: 'ORDER_3_CURRICULUM_NAME',
        data_select: "order_3",
    },
    //---------ข้อมูลประวัติโรงเรียน กรณีสมัครระดับปริญญาตรี-------------
    {
        key_name: '12',
        use_translate: true,
        text: "applicants_report_list.school",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'SCHOOL_NAME',
        data_select: "school_name",
    },
    {
        key_name: '13',
        use_translate: false,
        text: "ประเภทโรงเรียน",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'SCHOOL_TYPE_NAME',
        data_select: "school_type",
    },
    {
        key_name: '14',
        use_translate: false,
        text: "แผนการศึกษา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'EDUCATION_TYPE_NAME',
        data_select: "education_type",
    },
    {
        key_name: '15',
        use_translate: false,
        text: "สถานภาพทางการศึกษา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'SCHOOL_STUDY_STATUS_NAME',
        data_select: "study_status",
    },
    {
        key_name: '16',
        use_translate: false,
        text: "ประเภทการศึกษา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'SCHOOL_STUDY_TYPE_NAME',
        data_select: "study_type",
    },
    {
        key_name: '17',
        use_translate: false,
        text: "จำนวนเทอมของ GPA",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_ungrad_TERM_OF_GPA',
        data_select: "term_of_gpa",
    },
    {
        key_name: '18',
        use_translate: false,
        text: "GPA",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_ungrad_GPA',
        data_select: "gpa",
    },
    // ---------ข้อมูลเพิ่มเติม สำหรับนานาชาติ-------------
    {
        key_name: '19',
        use_translate: false,
        text: "ประวัติการศึกษา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_DIPLOMA_TYPE',
        data_select: "inter_info",
    },
    {
        key_name: '20',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #1 name)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_1_NAME',
        data_select: "inter_info",
    },
    {
        key_name: '21',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #1 score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_1_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '22',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #1 วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_1_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '23',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #2 name)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_2_NAME',
        data_select: "inter_info",
    },
    {
        key_name: '24',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #2 score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_2_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '25',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #2 วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_2_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '26',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #3 name)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_3_NAME',
        data_select: "inter_info",
    },
    {
        key_name: '27',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #3 score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_3_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '28',
        use_translate: false,
        text: "AP/IB/IGCSE TEST SCORE (Subject #3 วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SUBJECT_3_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '29',
        use_translate: false,
        text: "GED (Reasoning Through Language Arts)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GED_RTLA_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '30',
        use_translate: false,
        text: "GED (Mathematical Reasoning)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GED_MR_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '31',
        use_translate: false,
        text: "GED (Science)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GED_SCI_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '32',
        use_translate: false,
        text: "GED (Social Studies)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GED_SS_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '33',
        use_translate: false,
        text: "GED (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GED_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '34',
        use_translate: false,
        text: "SAT I (Mathematics)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_1_MATH_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '35',
        use_translate: false,
        text: "SAT I (readingWriting)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_1_RW_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '36',
        use_translate: false,
        text: "SAT I (Total)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_1_TOTAL_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '37',
        use_translate: false,
        text: "SAT I (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_1_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '38',
        use_translate: false,
        text: "OLD SAT Subject test (Verbal)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OLD_SAT_VERBAL_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '39',
        use_translate: false,
        text: "OLD SAT Subject test (Mathematics)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OLD_SAT_MATH_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '40',
        use_translate: false,
        text: "OLD SAT Subject test (Writing)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OLD_SAT_WRITING_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '41',
        use_translate: false,
        text: "OLD SAT Subject test (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OLD_SAT_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '42',
        use_translate: false,
        text: "SAT II (Biology)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_2_BIO_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '43',
        use_translate: false,
        text: "SAT II (Chemistry)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_2_CHEM_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '44',
        use_translate: false,
        text: "SAT II (Physics)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_2_PHY_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '45',
        use_translate: false,
        text: "SAT II (Mathematics)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_2_MATH_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '46',
        use_translate: false,
        text: "SAT II (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_SAT_2_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '47',
        use_translate: false,
        text: "ACT (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_ACT_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '48',
        use_translate: false,
        text: "ACT (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_ACT_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '49',
        use_translate: false,
        text: "IB (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_IB_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '50',
        use_translate: false,
        text: "IB (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_IB_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '51',
        use_translate: false,
        text: "GAT 1 (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GAT_1_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '52',
        use_translate: false,
        text: "GAT 2 (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GAT_2_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '53',
        use_translate: false,
        text: "GAT (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_GAT_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '54',
        use_translate: false,
        text: "PAT 1 (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_PAT_1_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '55',
        use_translate: false,
        text: "PAT 3 (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_PAT_3_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '56',
        use_translate: false,
        text: "PAT (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_PAT_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '57',
        use_translate: false,
        text: "TOEFL (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_TOFEL_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '58',
        use_translate: false,
        text: "TOEFL (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_TOFEL_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '59',
        use_translate: false,
        text: "IELTS (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_IELTS_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '60',
        use_translate: false,
        text: "IELTS (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_IELTS_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '61',
        use_translate: false,
        text: "KMITL TEP (Score)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_KMITL_TEP_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '62',
        use_translate: false,
        text: "KMITL TEP (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_KMITL_TEP_TEST_DATE',
        data_select: "inter_info",
    },
    {
        key_name: '63',
        use_translate: false,
        text: "Other name",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OTHER_NAME',
        data_select: "inter_info",
    },
    {
        key_name: '64',
        use_translate: false,
        text: "Other score",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OTHER_SCORE',
        data_select: "inter_info",
    },
    {
        key_name: '65',
        use_translate: false,
        text: "วันที่สอบ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_inter_OTHER_TEST_DATE',
        data_select: "inter_info",
    },


    //---------ข้อมูลเพิ่มเติม สำหรับแพทย์------------

    {
        key_name: '66',
        use_translate: false,
        text: "ประวัติการศึกษา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_DIPLOMA_TYPE',
        data_select: "med_info",
    },
    {
        key_name: '67',
        use_translate: false,
        text: "SAT II (Biology)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SAT_2_BIO_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '68',
        use_translate: false,
        text: "SAT II (Chemistry)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SAT_2_CHEM_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '69',
        use_translate: false,
        text: "SAT II (Physics)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SAT_2_PHY_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '70',
        use_translate: false,
        text: "SAT II (Mathematics)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SAT_2_MATH_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '71',
        use_translate: false,
        text: "SAT II (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SAT_2_TEST_DATE',
        data_select: "med_info",
    },
    {
        key_name: '72',
        use_translate: false,
        text: "BMAT (Section 1)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_BMAT_SECTION_1_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '73',
        use_translate: false,
        text: "BMAT (Section 2)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_BMAT_SECTION_2_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '74',
        use_translate: false,
        text: "BMAT (Section 3)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_BMAT_SECTION_3_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '75',
        use_translate: false,
        text: "BMAT (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_BMAT_TEST_DATE',
        data_select: "med_info",
    },
    {
        key_name: '76',
        use_translate: false,
        text: "กสพท (คะแนน)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SPOT_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '77',
        use_translate: false,
        text: "กสพท (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_SPOT_TEST_DATE',
        data_select: "med_info",
    },
    {
        key_name: '78',
        use_translate: false,
        text: "TOEFL (Internet based)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_TOEFL_IBT_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '79',
        use_translate: false,
        text: "TOEFL (Paper based)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_TOEFL_PBT_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '80',
        use_translate: false,
        text: "TOEFL (Computer based)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_TOEFL_CBT_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '81',
        use_translate: false,
        text: "TOEFL (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_TOFEL_TEST_DATE',
        data_select: "med_info",
    },
    {
        key_name: '82',
        use_translate: false,
        text: "IELTS (Academic Module)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_IELTS_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '83',
        use_translate: false,
        text: "IELTS (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_IELTS_TEST_DATE',
        data_select: "med_info",
    },
    {
        key_name: '84',
        use_translate: false,
        text: "CU-TEP (คะแนน)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_CU_TEP_SCORE',
        data_select: "med_info",
    },
    {
        key_name: '85',
        use_translate: false,
        text: "CU-TEP (วันที่สอบ)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_CU_TEP_TEST_DATE',
        data_select: "med_info",
    },
    {
        key_name: '86',
        use_translate: false,
        text: "Personal statement",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_medicine_PERSONAL_STATEMENT',
        data_select: "med_info",
    },
    //---------ข้อมูลประวัติการศึกษา กรณีสมัครระดับบัณฑิตศึกษา------------
    {
        key_name: '87',
        use_translate: false,
        text: "มหาวิทยาลัย (ป.ตรี)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'UNIVERSITY_NAME',
        data_select: "undergraduate_info",
    },
    {
        key_name: '88',
        use_translate: false,
        text: "ปีที่สำเร็จการศึกษา (ป.ตรี)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_GRADUATED_YEAR',
        data_select: "undergraduate_info",
    },
    {
        key_name: '89',
        use_translate: false,
        text: "สถานภาพการศึกษา (ป.ตรี)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'UNIVERSITY_STUDY_STATUS_NAME',
        data_select: "undergraduate_info",
    },
    {
        key_name: '90',
        use_translate: false,
        text: "คุณวุฒิ/ปริญญา (ป.ตรี)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_DEGREE_NAME',
        data_select: "undergraduate_info",
    },
    {
        key_name: '91',
        use_translate: false,
        text: "สาขา (ป.ตรี)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_CURRICULUM_NAME',
        data_select: "undergraduate_info",
    },
    {
        key_name: '92',
        use_translate: false,
        text: "GPA (ป.ตรี)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_GPA',
        data_select: "undergraduate_info",
    },
    {
        key_name: '93',
        use_translate: false,
        text: "มหาวิทยาลัย (ป.โท)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'MASTER_UNIVERSITY_NAME',
        data_select: "master_info",
    },
    {
        key_name: '94',
        use_translate: false,
        text: "ปีที่สำเร็จการศึกษา (ป.โท)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_MASTER_GRADUATED_YEAR',
        data_select: "master_info",
    },
    {
        key_name: '95',
        use_translate: false,
        text: "สถานภาพการศึกษา (ป.โท)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'object_translator',
        data_name: 'MASTER_UNIVERSITY_STUDY_STATUS_NAME',
        data_select: "master_info",
    },
    {
        key_name: '96',
        use_translate: false,
        text: "คุณวุฒิ/ปริญญา (ป.โท)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_MASTER_DEGREE_NAME',
        data_select: "master_info",
    },
    {
        key_name: '97',
        use_translate: false,
        text: "สาขา (ป.โท)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_MASTER_CURRICULUM_NAME',
        data_select: "master_info",
    },
    {
        key_name: '98',
        use_translate: false,
        text: "GPA (ป.โท)",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'edubg_grad_MASTER_GPA',
        data_select: "master_info",
    },
    //-----------------ข้อมูลประกอบการสมัคร-----------------------
    {
        key_name: '99',
        use_translate: false,
        text: "GPA รวมทุกวิชา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_2',
        data_select: "constarint_2",
    },
    {
        key_name: '100',
        use_translate: false,
        text: "GPA วิชาภาษาไทย",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_3',
        data_select: "constarint_3",
    },
    {
        key_name: '101',
        use_translate: false,
        text: "หน่วยกิต วิชาภาษาไทย",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_4',
        data_select: "constarint_4",
    },
    {
        key_name: '102',
        use_translate: false,
        text: "GPA วิชาคณิตศาสตร์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_5',
        data_select: "constarint_5",
    },
    {
        key_name: '103',
        use_translate: false,
        text: "หน่วยกิต วิชาคณิตศาสตร์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_6',
        data_select: "constarint_6",
    },
    {
        key_name: '104',
        use_translate: false,
        text: "GPA วิชาวิทยาศาสตร์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_7',
        data_select: "constarint_7",
    },
    {
        key_name: '105',
        use_translate: false,
        text: "หน่วยกิต วิชาวิทยาศาสตร์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_8',
        data_select: "constarint_8",
    },
    {
        key_name: '106',
        use_translate: false,
        text: "GPA วิชาฟิสิกส์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_9',
        data_select: "constarint_9",
    },
    {
        key_name: '107',
        use_translate: false,
        text: "หน่วยกิต วิชาฟิสิกส์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_10',
        data_select: "constarint_10",
    },
    {
        key_name: '108',
        use_translate: false,
        text: "GPA วิชาเคมี",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_11',
        data_select: "constarint_11",
    },
    {
        key_name: '109',
        use_translate: false,
        text: "หน่วยกิต วิชาเคมี",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_12',
        data_select: "constarint_12",
    },
    {
        key_name: '110',
        use_translate: false,
        text: "GPA วิชาชีววิทยา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_13',
        data_select: "constarint_13",
    },
    {
        key_name: '111',
        use_translate: false,
        text: "หน่วยกิต วิชาชีววิทยา",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_14',
        data_select: "constarint_14",
    },
    {
        key_name: '112',
        use_translate: false,
        text: "GPA วิชาวิทยาศาสตร์ และ คณิตศาสตร์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_15',
        data_select: "constarint_15",
    },
    {
        key_name: '113',
        use_translate: false,
        text: "หน่วยกิต วิชาวิทยาศาสตร์ และ คณิตศาสตร์",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_16',
        data_select: "constarint_16",
    },
    {
        key_name: '114',
        use_translate: false,
        text: "GPA วิชาภาษาอังกฤษ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_17',
        data_select: "constarint_17",
    },
    {
        key_name: '115',
        use_translate: false,
        text: "หน่วยกิต วิชาภาษาอังกฤษ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_18',
        data_select: "constarint_18",
    },
    {
        key_name: '116',
        use_translate: false,
        text: "GPA วิชาภาษาต่างประเทศ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_20',
        data_select: "constarint_20",
    },
    {
        key_name: '117',
        use_translate: false,
        text: "หน่วยกิต วิชาภาษาต่างประเทศ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_21',
        data_select: "constarint_21",
    },
    {
        key_name: '118',
        use_translate: false,
        text: "ชื่อมาตรฐานความรู้ภาษาอังกฤษ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_22',
        data_select: "constarint_22",
    },
    {
        key_name: '119',
        use_translate: false,
        text: "คะแนนสอบมาตรฐานความรู้ภาษาอังกฤษ",
        mode: "show_only_on_detail_mode",
        text_mode: "left",
        display_mode: 'normal',
        data_name: 'user_constraint_CONSTRAINT_ID_23',
        data_select: "constarint_23",
    },
]